
import { useEffect, useState } from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { ButtonCP } from './components/ButtonCP';
import { EditText } from './components/EditText';
import { EditTextPassword } from './components/EditTextPassword';
import { login } from './repository/login';
import { VirtualTerminal } from './VirtualTerminal';

export default function App() {

  const [username, setUsername] = useState("merchantfismg")
  const [password, setPassword] = useState("Newc12345!")
  const [wait, setWait] = useState(false)
  const [token, setToken] = useState()
  const [type, setType] = useState()

  const loginHandler = async () => {

    if(username.trim().length === 0 || password.trim().length === 0 ){
      return
    }
    setWait(true)

    const response = await login(username, password)
    console.log(response)
    setWait(false)
    if(response.access_token)
      setToken(response)
  }

  return (
    <View style={styles.container}>
        {token === undefined? <>
           <Text style={styles.passwordMargin} >Initiate payment</Text>
            {wait? <ActivityIndicator size={'large'} style={styles.buttonMargin}/>:<ButtonCP text="Start" style={styles.buttonMargin} onPress={loginHandler}/>}
          </>
          : <VirtualTerminal token={token} type={"FIS"}/>
        }
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonMargin: {
      marginTop: 32
  },
  passwordMargin: {
    marginTop: 8
  },
}
);